import { render, staticRenderFns } from "./email_setting.vue?vue&type=template&id=fd02dadc&scoped=true&"
import script from "./email_setting.vue?vue&type=script&lang=js&"
export * from "./email_setting.vue?vue&type=script&lang=js&"
import style0 from "./email_setting.vue?vue&type=style&index=0&id=fd02dadc&lang=scss&scoped=true&"
import style1 from "./email_setting.vue?vue&type=style&index=1&id=fd02dadc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd02dadc",
  null
  
)

export default component.exports